module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "bg-primary-dark"
  }, [_c('section', {
    staticClass: "content content-full content-boxed"
  }, [_c('div', {
    staticClass: "push-10-t push-10 text-center"
  }, [_c('h1', {
    staticClass: "h2 text-white push-10",
    attrs: {
      "data-class": "animated fadeInDown"
    }
  }, [_vm._v(_vm._s(_vm.labelTopTitle01[_vm.actualLanguage]))]), _vm._v(" "), _c('h1', {
    staticClass: "h3 text-white push-10",
    attrs: {
      "data-class": "animated fadeInDown"
    }
  }, [_vm._v(_vm._s(_vm.labelTopTitle02[_vm.actualLanguage]) + " " + _vm._s(_vm.policyEndPoint))]), _vm._v(" "), _c('h2', {
    staticClass: "h5 text-white-op",
    attrs: {
      "data-class": "animated fadeInDown"
    }
  }, [_vm._v(_vm._s(_vm.labelTopTitle03[_vm.actualLanguage]))]), _vm._v(" "), _c('h2', {
    staticClass: "h5 text-white-op",
    attrs: {
      "data-class": "animated fadeInDown"
    }
  }, [_vm._v(_vm._s(_vm.labelTopTitle04[_vm.actualLanguage]))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('div', {
    staticClass: "push-10-t push-10 text-center"
  }, [_c('h4', {
    attrs: {
      "data-class": "animated fadeInDown"
    }
  }, [_vm._v(_vm._s(_vm.labelTopFilePreview[_vm.actualLanguage]))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('p', [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "width": "600px",
      "src": _vm._f("s3Image")(("politicsPreview/" + (_vm.policyConditionUtilizationPreviewImg[_vm.actualLanguage])))
    },
    on: {
      "click": function($event) {
        return _vm.openUtilizationConditions()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('p', [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "width": "600px",
      "src": _vm._f("s3Image")(("politicsPreview/" + (_vm.policyConfidentialPoliticsPreviewImg[_vm.actualLanguage])))
    },
    on: {
      "click": function($event) {
        return _vm.openConfidentialityPolitics()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-ms-12"
  }, [_c('label', {
    staticClass: "css-input css-checkbox css-checkbox-lg css-checkbox-success align-center"
  }, [_c('div', {
    staticClass: "col-ms-6"
  }, [_c('h3', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.acceptConditionFlag),
      expression: "acceptConditionFlag"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.acceptConditionFlag) ? _vm._i(_vm.acceptConditionFlag, null) > -1 : (_vm.acceptConditionFlag)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.acceptConditionFlag,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.acceptConditionFlag = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.acceptConditionFlag = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.acceptConditionFlag = $$c
        }
      }
    }
  }), _c('span'), _vm._v(_vm._s(_vm.labelConfirmCheckBox[_vm.actualLanguage]))])])])]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.acceptConditionFlag) ? _c('div', {
    staticClass: "col-ms-12"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('h3', {
    staticClass: "h5 font-w600 text-uppercase push-10"
  }, [_vm._v(_vm._s(_vm.labelCookiesTitle[_vm.actualLanguage]))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.labelConfirmCookiesConditions[_vm.actualLanguage]))]), _vm._v(" "), _c('label', {
    staticClass: "css-input css-checkbox css-checkbox-lg css-checkbox-success align-center"
  }, [_c('div', {
    staticClass: "col-ms-6"
  }, [_c('h3', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.acceptCookieFlag),
      expression: "acceptCookieFlag"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.acceptCookieFlag) ? _vm._i(_vm.acceptCookieFlag, null) > -1 : (_vm.acceptCookieFlag)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.acceptCookieFlag,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.acceptCookieFlag = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.acceptCookieFlag = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.acceptCookieFlag = $$c
        }
      }
    }
  }), _c('span'), _vm._v(_vm._s(_vm.labelConfirmCookiesCheckBox[_vm.actualLanguage]))])])])])]) : _vm._e(), _vm._v(" "), (_vm.acceptCookieFlag) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-success align-left",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveMyAgreement()
      }
    }
  }, [_vm._v(_vm._s(_vm.labelButtonAcceptCondition[_vm.actualLanguage]))])])]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-be45185e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PolicyAgreement.vue
// module id = 1582
// module chunks = 4